import convertFormData from '@module/utils/convertFormData';
import { getFormData } from '@module/utils/getFormData';
import SettingConfig from '../../../config/setting';
import convertFormDataWithArray from '../../../utils/convertFormDataWithArray';
import { fetchExtended } from '../../../utils/fetch/client-fetch';
import type { ApiBaseResponse } from '../../type';
import type {
  AddMemberJoinParams,
  AddMemberJoinResponse,
  ASPRefreshUserInfoResponse,
  AuthCheckParams,
  BjInfoParams,
  BjInfoResponse,
  ChangePasswordParams,
  DeleteProfileParams,
  EditChannelParams,
  EditFanGradeParams,
  FetchMemberFindResponse,
  IReadAlarmParam,
  MemberAccountInfoParams,
  MemberAccountInfoResponse,
  MemberAuthParams,
  MemberCheckIdExitsParams,
  MemberCheckIdExitsResponse,
  MemberCheckIdParams,
  MemberCheckIdResponse,
  MemberCheckNickParams,
  MemberCheckNickResponse,
  MemberEditInfoParams,
  MemberFindChangePasswordParams,
  MemberFindChangePasswordResponse,
  MemberFindParams,
  MemberIdNickInfoParams,
  MemberLoginInfoParams,
  MemberLoginParams,
  MemberLoginResponse,
  MemberLogoutResponse,
  MemberMemberLeaveParams,
  MemberMemberLeaveResponse,
  MemberNickChangeStatusRespanse,
  MemberSocialJoinParams,
  MemberSocialJoinResponse,
  MemberSocialLoginParams,
  MemberSocialLoginResponse,
  MemberSocialTokenParams,
  MemberSocialTokenResponse,
  ProtectRecoveryParams,
  RecoveryIdParams,
  RecoveryIdResponse,
  UnlockOverseaBlockParams,
  UploadBannerParams,
  UploadProfileParams,
} from './type';

const isMobile = SettingConfig.ENVIRONMENT.includes('m-');

export const authenticateMemberLogin = async (memberLoginParmas: MemberLoginParams) => {
  const res = await fetchExtended(`/v1/member/login`, {
    method: 'POST',
    credentials: 'include',
    body: convertFormData(memberLoginParmas),
  });

  const result = await res.json();
  return result as MemberLoginResponse;
};

export const addMemberJoin = async (addMemberJoinParams: AddMemberJoinParams) => {
  const res = await fetchExtended(`/v1/member/join`, {
    method: 'POST',
    body: convertFormData(addMemberJoinParams),
    credentials: 'include',
  });

  const result = await res.json();
  return result as AddMemberJoinResponse;
};

export const authenticateMemberLogout = async () => {
  const res = await fetchExtended(`/v1/member/logout`, {
    method: 'GET',
    credentials: 'include',
  });

  const result = await res.json();
  return result as MemberLogoutResponse;
};

export const authenticateMemberLoginInfo = async (memberLoginInfoParams: MemberLoginInfoParams) => {
  const res = await fetchExtended(`/v1/member/login_info`, {
    method: 'POST',
    credentials: 'include',
    cache: 'no-store',
    headers: {
      Accept: '*/*',
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Device-Info': JSON.stringify({
        t: isMobile ? 'webMobile' : 'webPc',
        v: '1.0',
        ui: memberLoginInfoParams?.userIdx || 0,
      }),
    },
    body: convertFormData(memberLoginInfoParams),
  });

  const result = await res.json();
  return result as MemberLoginResponse;
};

export const fetchASPRefreshUserInfo = async () => {
  const res = await fetchExtended(`/v1/member/refresh_user_info`, {
    method: 'GET',
    credentials: 'include',
  });

  const result = await res.json();
  return result as ASPRefreshUserInfoResponse;
};
export const fetchMemberCheckId = async (memberCheckIdParams: MemberCheckIdParams) => {
  const res = await fetchExtended(`/v1/member/check_id`, {
    method: 'POST',
    body: convertFormData(memberCheckIdParams),
    credentials: 'include',
  });

  const result = await res.json();
  return result as MemberCheckIdResponse;
};

export const fetchMemberCheckNick = async (memberCheckNickParams: MemberCheckNickParams) => {
  const res = await fetchExtended(`/v1/member/check_nick`, {
    method: 'POST',
    body: convertFormData(memberCheckNickParams),
    credentials: 'include',
  });

  const result = await res.json();
  return result as MemberCheckNickResponse;
};

export const fetchMemberSocialLogin = async (memberSocialLoginParams: MemberSocialLoginParams) => {
  const res = await fetchExtended(`/v1/member/social`, {
    method: 'POST',
    body: convertFormData(memberSocialLoginParams),
    credentials: 'include',
  });

  const result = await res.json();

  return result as MemberSocialLoginResponse;
};

export const fetchMemberSocialJoin = async (memberSocialJoinParams: MemberSocialJoinParams) => {
  const res = await fetchExtended(`/v1/member/socialJoin`, {
    method: 'POST',
    body: convertFormData(memberSocialJoinParams),
    credentials: 'include',
  });

  const result = await res.json();

  return result as MemberSocialJoinResponse;
};

export const fetchSocialToken = async (params: MemberSocialTokenParams) => {
  const res = await fetchExtended(`/v1/member/socialToken`, {
    method: 'POST',
    body: convertFormData(params),
  });

  const result = await res.json();

  return result as MemberSocialTokenResponse;
};

export const fetchMemberCheckIdExits = async (memberCheckIdExitsParams: MemberCheckIdExitsParams) => {
  const res = await fetchExtended(`/v1/member/check_id_exits`, {
    method: 'POST',
    body: convertFormData(memberCheckIdExitsParams),
    credentials: 'include',
  });

  const result = await res.json();

  return result as MemberCheckIdExitsResponse;
};

export const fetchMemberFindChangePassword = async (memberFindChangePasswordParams: MemberFindChangePasswordParams) => {
  const res = await fetchExtended(`/v1/member/findChangePassword`, {
    method: 'POST',
    body: convertFormData(memberFindChangePasswordParams),
    credentials: 'include',
  });

  const result = await res.json();

  return result as MemberFindChangePasswordResponse;
};

export const fetchChangePassword = async (params: ChangePasswordParams) => {
  const res = await fetchExtended(`/v1/member/change_password`, {
    method: 'POST',
    body: convertFormData(params),
    credentials: 'include',
  });

  const result = await res.json();

  return result as ApiBaseResponse;
};

export const fetchMemberLeave = async (memberMemberLeaveParams: MemberMemberLeaveParams) => {
  const res = await fetchExtended(`/v1/member/leave`, {
    method: 'POST',
    body: convertFormData(memberMemberLeaveParams),
    credentials: 'include',
  });

  const result = await res.json();

  return result as MemberMemberLeaveResponse;
};

export const fetchMemberIdInfo = async (params: MemberAccountInfoParams) => {
  const res = await fetchExtended(`/v1/member/idInfo`, {
    method: 'POST',
    credentials: 'include',
    body: convertFormData(params),
  });

  const result = await res.json();
  return result as MemberAccountInfoResponse;
};

export const fetchMemberIdNickInfo = async (params: MemberIdNickInfoParams) => {
  const res = await fetchExtended(`/v1/member/idNickInfo`, {
    method: 'POST',
    credentials: 'include',
    body: convertFormData(params),
  });

  const result = await res.json();
  return result as MemberAccountInfoResponse;
};

export const fetchMemberEditInfo = async (fetchMemberEditInfoParams: MemberEditInfoParams) => {
  const res = await fetchExtended(`/v1/member/edit_info`, {
    method: 'POST',
    credentials: 'include',
    body: convertFormData(fetchMemberEditInfoParams),
  });

  const result = await res.json();

  return result as ApiBaseResponse;
};

export const fetchMemberNickChangStatusConfirm = async () => {
  const res = await fetchExtended(`/v1/member/nick_change_status`, {
    method: 'GET',
    credentials: 'include',
  });

  const result = await res.json();

  return result as MemberNickChangeStatusRespanse;
};

export const fetchDeleteProfile = async (deleteProfileParams?: DeleteProfileParams) => {
  const res = await fetchExtended(`/v1/member/delete_profile`, {
    method: 'POST',
    credentials: 'include',
    body: convertFormData(deleteProfileParams),
  });

  const result = await res.json();

  return result as ApiBaseResponse & BjInfoResponse;
};

export const fetchUploadProfile = async (fetchUploadProfileParams: UploadProfileParams) => {
  const res = await fetchExtended(`/v1/member/upload_profile`, {
    method: 'POST',
    credentials: 'include',
    body: getFormData(fetchUploadProfileParams),
  });

  const result = await res.json();

  return result as ApiBaseResponse;
};

export const fetchBjInfo = async (fetchBjInfoParams: BjInfoParams) => {
  const res = await fetchExtended(`/v1/member/bj`, {
    method: 'POST',
    credentials: 'include',
    body: convertFormData(fetchBjInfoParams),
  });

  const result = await res.json();

  return result as BjInfoResponse;
};

export const readAlarm = async (ReadAlarmParam: IReadAlarmParam) => {
  const res = await fetchExtended(`/v1/alarm/list_read`, {
    method: 'POST',
    credentials: 'include',
    body: convertFormDataWithArray(ReadAlarmParam),
  });

  const result = await res.json();

  return result as ApiBaseResponse;
};

export const fetchEditChannel = async (fetchEditChannelParams: EditChannelParams) => {
  const res = await fetchExtended(`/v1/member/edit_channel`, {
    method: 'POST',
    credentials: 'include',
    body: convertFormData(fetchEditChannelParams),
  });

  const result = await res.json();

  return result as ApiBaseResponse;
};

export const fetchEditFanGrade = async (fetchEditFanGradeParams: EditFanGradeParams) => {
  const res = await fetchExtended(`/v1/member/edit_fan_grade`, {
    method: 'POST',
    credentials: 'include',
    body: convertFormData(fetchEditFanGradeParams),
  });

  const result = await res.json();

  return result as ApiBaseResponse;
};

export const fetchAuthCheck = async (fetchAuthCheckParams: AuthCheckParams) => {
  const res = await fetchExtended(`/v1/member/authCheck`, {
    method: 'POST',
    credentials: 'include',
    body: convertFormData(fetchAuthCheckParams),
  });

  const result = await res.json();

  return result as ApiBaseResponse;
};

export const fetchMemberAuth = async (params: MemberAuthParams) => {
  const res = await fetchExtended(`/v1/member/auth`, {
    method: 'POST',
    credentials: 'include',
    body: convertFormData(params),
  });

  const result = await res.json();

  return result as ApiBaseResponse;
};

export const fetchMemberFind = async (params: MemberFindParams) => {
  const res = await fetchExtended(`/v1/member/find`, {
    method: 'POST',
    credentials: 'include',
    body: convertFormData(params),
  });

  const result = await res.json();

  return result as FetchMemberFindResponse;
};

export const fetchUnlockOverseaBlock = async (params: UnlockOverseaBlockParams) => {
  const res = await fetchExtended(`/v1/member/unlock_oveasea_block`, {
    method: 'POST',
    credentials: 'include',
    body: convertFormData(params),
  });

  const result = await res.json();

  return result as ApiBaseResponse;
};

export const fetchRecoveryId = async (params: RecoveryIdParams) => {
  const res = await fetchExtended(`/v1/member/recovery_id`, {
    method: 'POST',
    credentials: 'include',
    body: convertFormData(params),
  });

  const result = await res.json();

  return result as RecoveryIdResponse;
};

export const fetchProtectRecovery = async (params: ProtectRecoveryParams) => {
  const res = await fetchExtended(`/v1/member/protectRecovery`, {
    method: 'POST',
    credentials: 'include',
    body: convertFormData(params),
  });

  const result = await res.json();

  return result as ApiBaseResponse;
};

export const fetchUploadBanner = async (params: UploadBannerParams) => {
  const res = await fetchExtended(`/v1/member/upload_channel_banner`, {
    method: 'POST',
    credentials: 'include',
    body: getFormData(params),
  });

  const result = await res.json();

  return result as ApiBaseResponse;
};
